// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1262":"3187d828","2698":"49a15e7f","3941":"1e2f1895","9001":"8ce6c7a7"}[chunkId] + ".chunk.css";
};